import React, { useContext } from "react";
import PageSection from "../../section";
import { ApplicationFlowContext } from "../../../../../route/application/authenticated/application-flow/applicationFlowContext";
import { ApplicationFlows } from "../../../../../route/application/authenticated/application-flow/types";
import AdditionalAccountApplicationFlowStepper from "../../../../../route/application/authenticated/application-flow/additionalAccountApplicationFlow/stepper";
import AdditionalCardApplicationFlowStepper from "../../../../../route/application/authenticated/application-flow/additionalCardApplicationFlow/stepper";
import FirstAccountApplicationFlowStepper from "../../../../../route/application/authenticated/application-flow/firstAccountApplicationFlow/stepper";
import GridMainLayout from "../../../../widgets/grid";
import GridItem from "../../grid-item";

import "./styles.scss";

const useSideBar = (): React.JSX.Element => {
  const { flow, activeChapterId } = useContext(ApplicationFlowContext);

  let navigationSideBar = null;

  switch (flow) {
    case ApplicationFlows.FIRST_BAA:
      navigationSideBar = (
        <FirstAccountApplicationFlowStepper activeChapterId={activeChapterId} />
      );
      break;
    case ApplicationFlows.NO_APPLICATIONS_FLOW:
      navigationSideBar = (
        <FirstAccountApplicationFlowStepper activeChapterId={activeChapterId} />
      );
      break;
    case ApplicationFlows.ADDITIONAL_CA:
      navigationSideBar = (
        <AdditionalCardApplicationFlowStepper
          activeChapterId={activeChapterId}
        />
      );
      break;
    case ApplicationFlows.ADDITIONAL_BAA:
      navigationSideBar = (
        <AdditionalAccountApplicationFlowStepper
          activeChapterId={activeChapterId}
        />
      );
      break;
  }

  return navigationSideBar;
};

export default function ApplicationPageContent({
  children,
}: {
  children: React.ReactNode;
}): React.JSX.Element {
  const navigationSideBar = useSideBar();

  return (
    <PageSection>
      <GridMainLayout>
        {navigationSideBar && (
          <GridItem
            className="scd-grid-padding-remove scd-navigation-application"
            size={{ lg: 4, xl: 4 }}
          >
            {navigationSideBar}
          </GridItem>
        )}
        <GridItem className="scd-container-base" size={{ lg: 8, xl: 8 }}>
          {children}
        </GridItem>
      </GridMainLayout>
    </PageSection>
  );
}
